import { render, staticRenderFns } from "./largeScreenEntrance.vue?vue&type=template&id=929f63a4&scoped=true"
import script from "./largeScreenEntrance.vue?vue&type=script&lang=js"
export * from "./largeScreenEntrance.vue?vue&type=script&lang=js"
import style0 from "./largeScreenEntrance.vue?vue&type=style&index=0&id=929f63a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929f63a4",
  null
  
)

export default component.exports